import React from 'react';
import { BoxProps, Box } from '@material-ui/core';

const Spacing = (props: BoxProps) => <Box height={24} {...props} />;

export default Spacing;
